import { useContext } from 'react';
import { FileMenuItemsContext } from '../Context';

export const useFileMenuItems = () => {
  const ctx = useContext(FileMenuItemsContext);

  return ctx;
};

export default useFileMenuItems;